/* eslint-disable react/prop-types */
import { Box, Grid, Typography, Link } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import { form, AppendixForm, AppendixForm1 } from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import BillBc26Table from "./components/table";
import Table3_12 from "./components/table-3-12";
import Table3_10 from "./components/table3-10";
import ModalContent from "./components/modalContent";
import ModalCommon from "components/Modal";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
export default function BillBc26() {
  const { formId, formField } = form;
  const { formIdAppendix, formFieldAppendix } = AppendixForm;
  const { formIdAppendix1, formFieldAppendix1 } = AppendixForm1;

  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([
    { name: "Mẫu.3.12(Kỳ báo cáo cuối cùng)", checked: false, symbol: "3.12" },
    { name: "Mẫu.3.10(Chuyển địa điểm)", checked: false, symbol: "3.10" },
  ]);
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };
  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        } else {
          return { ...item, checked: false };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 ? (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo tình hình sử dụng hóa đơn - BC26/AC
              </Typography>
              {/* <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
            (dành cho tổ chức, cá nhân kinh doanh đặt in, tự in)
          </Typography> */}
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />

                  <BillBc26Table
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        ) : (
          list
            .filter((item) => item.checked === true)
            .map((type, i) => {
              return type.symbol === "3.12" ? (
                <Box display="flex" flexDirection="column" pb={10} gap={3}>
                  <Box textAlign="center">
                    <Typography variant="h4" textTransform="uppercase">
                      Bảng kê chi tiết hóa đơn của tổ chức, cá nhân đến thời điểm quyết toán hóa đơn
                    </Typography>
                    <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                      (Đính kèm báo cáo tình hình sử dụng hóa đơn BC26/AC)
                    </Typography>
                  </Box>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validation}
                    onSubmit={handleSubmit}
                  >
                    {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                      <Form id={formIdAppendix} autoComplete="off">
                        <AppendixFields
                          formData={{
                            values,
                            touched,
                            formFieldAppendix,
                            errors,
                          }}
                        />

                        <Table3_12
                          formData={{
                            values,
                            touched,
                            formFieldAppendix,
                            errors,
                          }}
                          setFieldValue={setFieldValue}
                        />
                        <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                          <SoftButton
                            disabled={isSubmitting}
                            type="submit"
                            variant="gradient"
                            color="dark"
                          >
                            {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                          </SoftButton>
                        </SoftBox>
                      </Form>
                    )}
                  </Formik>
                </Box>
              ) : (
                <Box display="flex" flexDirection="column" pb={10} gap={3}>
                  <Box textAlign="center">
                    <Typography variant="h4" textTransform="uppercase">
                      Bảng kê hóa đơn chưa sử dụng của tổ chức, cá nhân chuyển địa điểm kinh doanh
                      khác địa bàn cơ quan thuế quản lý
                    </Typography>
                    <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                      (Đính kèm báo cáo tình hình sử dụng hóa đơn)
                    </Typography>
                  </Box>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validation}
                    onSubmit={handleSubmit}
                  >
                    {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                      <Form id={formIdAppendix1} autoComplete="off">
                        <AppendixFields1
                          formData={{
                            values,
                            touched,
                            formFieldAppendix1,
                            errors,
                          }}
                        />

                        <Table3_10
                          formData={{
                            values,
                            touched,
                            formFieldAppendix1,
                            errors,
                          }}
                          setFieldValue={setFieldValue}
                        />
                        <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                          <SoftButton
                            disabled={isSubmitting}
                            type="submit"
                            variant="gradient"
                            color="dark"
                          >
                            {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                          </SoftButton>
                        </SoftBox>
                      </Form>
                    )}
                  </Formik>
                </Box>
              );
            })
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { taxId, conpanyName, address, taxCalculationPeriod, lastTime, changePosition } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        {/* <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Link href="#" style={{ fontSize: "14px" }}>
            Mẫu tải bảng kê
          </Link>
        </Grid> */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            value={values.taxCalculationPeriod}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={lastTime.name} label={lastTime.label} value={values.lastTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={changePosition.name}
            label={changePosition.label}
            value={values.changePosition}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={conpanyName.name}
            label={conpanyName.label}
            value={values.conpanyName}
            error={errors.conpanyName && touched.conpanyName}
            success={values.conpanyName?.toString().length > 0 && !errors.conpanyName}
          />
        </Grid>{" "}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

function AppendixFields({ formData }) {
  const { formFieldAppendix, values, errors, touched } = formData;
  const { taxIdAppendix, conpanyNameAppendix } = formFieldAppendix;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={conpanyNameAppendix.name}
            label={conpanyNameAppendix.label}
            value={values.conpanyNameAppendix}
            error={errors.conpanyNameAppendix && touched.conpanyNameAppendix}
            success={
              values.conpanyNameAppendix?.toString().length > 0 && !errors.conpanyNameAppendix
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxIdAppendix.name}
            label={taxIdAppendix.label}
            value={values.taxIdAppendix}
            error={errors.taxIdAppendix && touched.taxIdAppendix}
            success={values.taxIdAppendix?.toString().length > 0 && !errors.taxIdAppendix}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
function AppendixFields1({ formData }) {
  const { formFieldAppendix1, values, errors, touched } = formData;
  const { taxIdAppendix1, conpanyNameAppendix1 } = formFieldAppendix1;
  console.log(formFieldAppendix1);
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={conpanyNameAppendix1.name}
            label={conpanyNameAppendix1.label}
            value={values.conpanyNameAppendix1}
            error={errors.conpanyNameAppendix1 && touched.conpanyNameAppendix1}
            success={
              values.conpanyNameAppendix1?.toString().length > 0 && !errors.conpanyNameAppendix1
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxIdAppendix1.name}
            label={taxIdAppendix1.label}
            value={values.taxIdAppendix1}
            error={errors.taxIdAppendix1 && touched.taxIdAppendix1}
            success={values.taxIdAppendix1?.toString().length > 0 && !errors.taxIdAppendix1}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
